// wherever you wire-up your tenant config, e.g. index.js or App.js entry
import { resolveEnv, resolveTenant, isOnOurPlatform, loadTenantConfig, applyTenantConfigToCSS } from "@whitelabel/utils";

(async function bootstrapConfig() {
  const env = resolveEnv();
  const tenant = resolveTenant();
  const onPlatform = isOnOurPlatform();

  console.log(
    `Running in ${env} for tenant ${tenant}, onPlatform=${onPlatform}`
  );
  const cfg = await loadTenantConfig(tenant);

  // 1) Apply tenant configuration to CSS using shared utility
  applyTenantConfigToCSS(cfg);

  // 2) JS-only config: hang on window, or pass into your services
  window.__TENANT_CFG__ = cfg;
})();
